import React from 'react';
import { gql } from '@apollo/client';
import {
  BooleanField,
  Datagrid,
  ReferenceManyField,
  Show,
  SimpleShowLayout,
  TextField,
} from 'react-admin';
import RichTextField from 'components/RichTextField';

const QualificationShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="long_name" />
      <TextField source="slug" />
      <TextField source="qualification_type" />
      <BooleanField source="admin_view_only" />
      <RichTextField source="instructions" />
      <ReferenceManyField
        label="Qualification Attributes"
        reference="QualificationAttribute"
        target="qualification_id"
      >
        <Datagrid bulkActionButtons={false} rowClick="show">
          <TextField label="ID" source="id" />
          <TextField source="name" />
          <TextField source="slug" sortable={false} />
          <TextField source="field_type" sortable={false} />
          <BooleanField source="required" sortable={false} />
          <BooleanField source="required_for_approval" sortable={false} />
          <TextField source="input_source" sortable={false} />
        </Datagrid>
      </ReferenceManyField>
    </SimpleShowLayout>
  </Show>
);

QualificationShow.query = gql`
  query GET_ONE($id: Int!) {
    qualification(id: $id) {
      id
      long_name
      slug
      qualification_type
      instructions
      status
      admin_view_only
    }
  }
`;

export default QualificationShow;
